<template>
    <v-main>
        <v-container fluid>
            <v-row cols="12">
                <v-col cols="12">
                    <tableDetailAccommodation ref="tableDetailAccommodation" />
                </v-col>
            </v-row>
        </v-container>
        <navbar title="ARES - OpenAI" type="openai" :home="true" @actionClick="actionClick" />
    </v-main>
</template>

<script>
    import navbar from '@/components/ui/navbars/navbar.vue';
    import tableDetailAccommodation  from '@/components/syst/openai/tableDetailAccommodation.vue';

    export default {        
        components: {
            navbar,
            tableDetailAccommodation,
        },
        data() {
            return {
            }
        },
        methods: {
            // Dummy callback for navBar
            actionClick() {
            },           
        },
    }
</script>

<style scoped>
</style>
